import { useEffect, useState } from "react"
import { Alert, Box, Button, CircularProgress, Container, Snackbar, Tab, Tabs, Typography } from "@mui/material"
import { useAuth } from "../../auth/AuthContext"
import { api } from "./api"
import Registrar from "./Registrar"
import Listagem from "./Listagem"
import TemaAcompanhamento from "./Tema"
import Importar from "./Importar"
import Analise from "./Analise"

export default function AcompanhamentoEquipamentos() {
  const { podeEditar } = useAuth()
  const [aba, setAba] = useState(0)
  const [opcoes, setOpcoes] = useState(null)
  const [erro, setErro] = useState("")
  const [mensagem, notificar] = useState("")
  const [tentativa, setTentativa] = useState(0)
  useEffect(() => {
    const abort = new AbortController()
    api("/opcoes", "GET", undefined, abort.signal).then(setOpcoes).catch(e => { if (e.name !== "AbortError") setErro(e.message) })
    return () => abort.abort()
  }, [tentativa])
  return <TemaAcompanhamento><Container maxWidth={false} disableGutters>
    <Typography variant="overline" color="text.secondary">Administração</Typography>
    <Typography variant="h5" fontWeight={600}>Acompanhamento de Equipamentos Alocados</Typography>
    <Tabs value={aba} onChange={(_,v) => setAba(v)} sx={{ mb: 3 }} variant="scrollable" scrollButtons="auto" aria-label="Acompanhamento de equipamentos"><Tab id="aba-registrar" label="Registrar" /><Tab id="aba-listagem" label="Listagem" /><Tab id="aba-importar" label="Importar" /><Tab id="aba-analise" label="Análise" /></Tabs>
    {erro ? <Alert severity="error" action={<Button onClick={() => { setErro(""); setTentativa(v => v + 1) }}>Tentar novamente</Button>}>{erro}</Alert> : !opcoes ? <CircularProgress aria-label="Carregando cadastros" /> : <Box role="tabpanel" aria-labelledby={["aba-registrar","aba-listagem","aba-importar","aba-analise"][aba]}>
      {aba === 0 ? <Registrar opcoes={opcoes} podeEditar={podeEditar("acompanhamento_equipamentos")} notificar={notificar} /> : aba === 1 ? <Listagem opcoes={opcoes} podeEditar={podeEditar("acompanhamento_equipamentos")} notificar={notificar} /> : aba === 2 ? <Importar opcoes={opcoes} podeEditar={podeEditar("acompanhamento_equipamentos")} concluido={m=>{notificar(m);setTentativa(v=>v+1)}} /> : <Analise opcoes={opcoes} />}
    </Box>}
    <Snackbar open={Boolean(mensagem)} autoHideDuration={7000} onClose={() => notificar("")}><Alert severity="success" onClose={() => notificar("")}>{mensagem}</Alert></Snackbar>
  </Container></TemaAcompanhamento>
}
